import { createFileRoute } from '@tanstack/react-router'
import { ProfileScreen } from '@/features/account/profile-screen'

export const Route = createFileRoute('/_authenticated/account/')({
  component: ProfileScreen,
})
